var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpandQueue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M15.5,10c-.28,0-.5,.22-.5,.5v3.8l-4.95-4.95c-.2-.2-.51-.2-.71,0s-.2,.51,0,.71l4.94,4.94h-3.79c-.28,0-.5,.22-.5,.5s.22,.5,.5,.5h4c.83,0,1.5-.67,1.5-1.5v-4c0-.28-.22-.5-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.5,0h-4c-.28,0-.5,.22-.5,.5s.22,.5,.5,.5h3.79l-4.95,4.95c-.2,.2-.2,.51,0,.71,.1,.1,.23,.15,.35,.15s.26-.05,.35-.15L15,1.71v3.79c0,.28,.22,.5,.5,.5s.5-.22,.5-.5V1.5c0-.83-.67-1.5-1.5-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M5.94,9.35L1,14.29v-3.82c0-.28-.22-.5-.5-.5s-.5,.22-.5,.5v4.02c0,.83,.67,1.5,1.5,1.5H5.5c.28,0,.5-.22,.5-.5s-.22-.5-.5-.5H1.71l4.94-4.94c.2-.2,.2-.51,0-.71s-.51-.2-.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1.7,1h3.8c.28,0,.5-.22,.5-.5s-.22-.5-.5-.5H1.5C.67,0,0,.67,0,1.5V5.5c0,.28,.22,.5,.5,.5s.5-.22,.5-.5V1.71L5.94,6.66c.1,.1,.23,.15,.35,.15s.26-.05,.35-.15c.2-.2,.2-.51,0-.71L1.7,1Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandQueue);
export default __webpack_public_path__ + "static/media/expandQueue.f2931ec31b5b8608b596eba1085ba8a3.svg";
export { ForwardRef as ReactComponent };